import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Cotisation } from '../../types';

export type State = Cotisation[];

const initialState: State = [];

export const CotisationSlice = createSlice({
  name: 'cotisations',
  initialState,
  reducers: {
    onSetCotisation: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.date.date - a.date.date);
    },
    onDeleteCotisation: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetCotisation, onDeleteCotisation } = CotisationSlice.actions;

export default CotisationSlice.reducer;
